export const SECTIONS = [
  {
    name: "name1",
    url: "https://youtube.com/embed/GCQP6YuBQCg",
  },
  {
    name: "name2",
    url: "https://youtube.com/embed/yd5pi30pFSk",
  },
  {
    name: "name3",
    url: "https://youtube.com/embed/9w3jME_DB9Y",
  },
  {
    name: "name4",
    url: "https://youtube.com/embed/nElyRLirDT8",
  },
  {
    name: "name5",
    url: "https://youtube.com/embed/GCiBzLEXkDg",
  },
  {
    name: "name6",
    url: "https://youtube.com/embed/lreg8dXyF1s",
  },
  {
    name: "name7",
    url: "https://youtube.com/embed/dSNWBVt6KZE",
  },
  {
    name: "name8",
    url: "https://youtube.com/embed/-TH1dvsVQk4",
  },
  {
    name: "name9",
    url: "https://youtube.com/embed/rSTu1Qt7Gic",
  },
  {
    name: "name10",
    url: "https://youtube.com/embed/OD-7045aegA",
  },
  {
    name: "name11",
    url: "https://youtube.com/embed/1P48Pzf6uI8",
  },
  {
    name: "name12",
    url: "https://youtube.com/embed/KKPdn_ZH8LU",
  },
  {
    name: "name13",
    url: "https://youtube.com/embed/ymWlQxR7GME",
  },
  {
    name: "name14",
    url: "https://youtube.com/embed/v4qVzJHG2to",
  },
  {
    name: "name15",
    url: "https://youtube.com/embed/a_fhRvzqxCM",
  },
];
